<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- ON-DEMAND -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">On-Demand CE Webinars</span>
                </div>
              </b-col>
            </b-row>
            <searchbar v-model="searchModel" @remove-filter="removeFilter"></searchbar>
            <b-row v-if="!noResults">
              <b-col cols="12">
                  <span class="txt-section-subtitle red">Available Now: {{totalRows | prettyNumber}} On-Demand Webinars</span>
              </b-col>
            </b-row>
            <b-row v-if="isFiltered && !noResults">
              <b-col cols="12" class="text-left">
                <b-link @click.prevent="searchAllContent">Show All Related Content &raquo;</b-link>
              </b-col>
            </b-row>
          </div>

          <b-alert v-model="noResults" class="mt-3" variant="info">
            No results found for this search.
          </b-alert>

          <!-- TBD classList component. -->
          <div class="div-section-body" v-if="!noResults">

            <div v-if="this.curPage === 1 && featuredClass !== null">
              <!-- Featured Cat Content -->
              <vpfeaturedcontent :fc=featuredClass :fp=null :fb=null :fh=featuredHash></vpfeaturedcontent>
            </div>

            <div v-for="(row,ix) in classes" v-bind:key="row.classId">
              <div v-if="showMobileAd(ix)">
                <mobilead :mb="getMobileAd(ix)"></mobilead>
              </div>
              <div v-if="featuredClass === null || featuredClass.classId !== row.classId">
                <b-row class="mt-3 pointer" @click.prevent="gotoClass(row.hash)">
                    <b-col cols="4">
                      <div class="text-center">
                        <b-img fluid v-bind:src="row.photo" />
                        <div v-if="row.examTaken" class="text-center completed">COMPLETED</div>
                      </div>
                    </b-col>
                    <b-col cols="8" style="margin-left: -20px;">
                      <div class="class-title">{{row.className}}</div>
                      <div class="class-details">
                        {{row.speakerName}}
                        <br>Sponsor: {{row.sponsorCompanyName}}
                        <br>{{row.releaseDateUTC | prettyDate}} - {{row.credits}} CEU ({{row.creditName}})
                      </div>
                      <div class="mt-2" v-if="false">
                        <b-button :to="{ path: '/classroom/'+row.hash }">Enter Classroom</b-button>
                      </div>
                    </b-col>
                </b-row>
              </div>
            </div>

            <b-row v-if="pages > 1" class="mt-4">
              <b-col>
                <b-pagination align="center" v-model="curPage" :total-rows="totalRows" :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
              </b-col>
            </b-row>
          </div>

        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service";
import utils from "@/utils/utils"

export default {
  name: "Ondemand",
  data() {
    return {
      debug: false,
      loading: true,
      busy: false,
      error: false,
      studentHash: this.$root.getToken(),
      msg: "On-Demand CE",
      blurb: "Classes: 0",
      classes: [],
      featuredClass: null,
      featuredHash: null,
      mobileAds: null,
      adIndexArr: [],  // indexer into mobileAds.banners[]
      totalRows: 0,
      pageSize: 0,
      pages: 0,     // computed # of pages
      curPage: 1,
      searchModel: {
        path: '/ondemand',
        label: 'Search On-Demand Webinars',
        catId: this.$route.query.cid || null,
        compId: this.$route.query.coid || null,
        query: this.$route.query.q || null
      }
    }
  },
  props: {
    page: {
      type: String,
      required: false,
      default: '1'
    }
  },
  computed: {
    rows () {
      return this.classes.length
    },
    noResults() {
      return (this.classes.length == 0)
    },
    isFiltered() {   // return true if page is filtered
      let aout =  (this.searchModel.catId != null)
        || (this.searchModel.compId != null)
        || (this.searchModel.query != null)
      return aout
    }
  },
  methods: {
    gotoClass(hash) {
      this.$router.push(`/classroom/${hash}`)
    },
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doOndemand()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      let link = `/ondemand/${pageNum}`
      link += encodeURI(`?cid=${utils.ifNull(this.searchModel.catId,'')}&coid=${utils.ifNull(this.searchModel.compId,'')}&q=${utils.ifNull(this.searchModel.query,'')}`)
      // console.log(`pageNum: ${pageNum}  link: ${link}`)
      return link
    },
    setCurPage() {
      try {
        this.curPage = parseInt(this.page)
        if (this.curPage <= 0) this.curPage = 1
      }
      catch(e) {
        this.curPage = 1
      }
      // console.log( `this.page: ${this.page}  curPage: ${this.curPage}`)
    },
    removeFilter() {
      this.searchModel.catId = null
      this.searchModel.compId = null
      this.searchModel.query = null
      this.doOndemand()
    },
    searchAllContent() {
      this.$router.push({ path: '/search', query: {cid: this.searchModel.catId, coid: this.searchModel.compId, q: this.searchModel.query }})
    },
    showMobileAd(ix) { // returns boolean indicating whether slot has mobile ad
      return this.adIndexArr[ix] !== -1
    },
    getMobileAd(ix) {
      let aout = {adId: 0, adUrls: []}
      if (this.adIndexArr[ix] != -1) {
        aout = this.mobileAds.banners[this.adIndexArr[ix]]
      }
      // console.log(aout)
      return aout
    },
    doOndemand() {
      this.loading = true
      this.classes = []

      this.featuredClass = null
      this.featuredHash = null

      service
        .getOndemand(this.studentHash, this.searchModel.catId, this.searchModel.compId, this.searchModel.query, this.curPage-1)
        .then( res => {
          if (this.debug) console.log(res);
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Classes: ${res.rowCount}`
            this.classes = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
            if (this.curPage > this.pages) this.curPage = this.pages

            this.mobileAds = (res.mobileAds) ? res.mobileAds : {indexStart:0, interval: 0, rows: 0, banners: []}
            this.adIndexArr = utils.getAdIndexArray( this.classes.length, this.mobileAds.banners.length, this.mobileAds.indexStart, this.mobileAds.interval )

            // this.featuredClass = (res.featuredClass) ? res.featuredClass.data[0] : null
            if (res.featuredContent.status) {
              this.featuredClass = (res.featuredContent.featuredClass) ? res.featuredContent.featuredClass.data[0] : null
              this.featuredHash = res.featuredContent.featuredHash
            }
          }
          else {
            this.blurb = "No classes found.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e))
    }
  },
  created() {
    // this.setCurPage()
    this.doOndemand()
  },
  beforeDestroy() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ondemand.vue